import type { ApplicationInfosResponse } from '../types'

type RecipientCount = {
  /** Applications an email can actually be written to */
  addressed: number
  /** Addresses among them, once each */
  distinct: number
}

/**
 * Mirrors the backend rule: the response goes to the linked applicant when there is one, to the
 * address of the application otherwise. A bulk processing writes to each address only once, so
 * `distinct` below `addressed` means the selection holds several applications of a same candidate.
 */
export const countDistinctRecipients = (
  applications: ApplicationInfosResponse[]
): RecipientCount => {
  const addresses = applications
    .map((application) =>
      (application.applicant?.email || application.email || '')
        .trim()
        .toLowerCase()
    )
    .filter((address) => address !== '')

  return { addressed: addresses.length, distinct: new Set(addresses).size }
}
